<template>
  <div id="app">
    <!-- 提示页面 -->
    <app-tips 
    :tipInfo="tipInfo" 
    :btnshow="btnshow"
    :btnreload="btnreload"
    :btnpay="btnpay"
    :imei="imei"
    :order="order"
    @tipShow="tipShow" 
    v-show="tipshow"></app-tips>

  <pay-status
    :is_success = "is_success"
    :error_message = "error_message"
  ></pay-status>
  </div>
</template>

<script>
import payStatus from './components/payPage/payStatus'
import Tips from './components/tips/Tips'
export default {
  name: 'App',
  components:{
      "pay-status":payStatus,
      "app-tips":Tips,
  },
  data(){
    return{
      order:'',
      putOrderInfo:{
            order:"",
      },//提交的订单信息
      tipInfo:"",
      tipshow:false,
      btnshow:true,
      btnreload:false,
      btnpay:false,
      tipReload:false,//tips页面是否刷新页面
      commentNum:0,
      source:0,//入口  微信 WeiXIN  支付宝 Alipay
      machineId:"",//货机id
      imei:"",
      res:{},
      showPayBtn:true,
      checkPage: false,
      checkMessage: '',
      is_success: '',
      error_message: '',

    }
  },

  created(){
    //console.log(this)
    if(this.$route.query.order){
      this.order = this.$route.query.order
    }
    console.log(this.order)
    if(this.order != ""){
      this.handleConfirm()
    }

    if(this.$route.query.is_success){
      this.is_success = this.$route.query.is_success
    }
    if(this.$route.query.error_message){
      this.error_message = this.$route.query.error_message
    }
    
    //识别扫描入口
    var ua = window.navigator.userAgent.toLowerCase();
    if ( ua.match(/MicroMessenger/i) == 'micromessenger' ) {  
          //判断是不是微信
          this.source = 1;
          

    } else if (ua.match(/AlipayClient/i) == 'alipayclient') {
        //判断是不是支付宝
        this.source = 2;
        
    } else {
        //哪个都不是退出
        alert('请使用微信或支付宝扫码，谢谢！');
        this.tipInfo = "请使用微信或支付宝扫码，谢谢！";
        this.tipshow = true;
        this.btnshow = false;
        setTimeout(function(){
          window.opener=null;
          window.close();
        },3000)
        return ;
    }
  },
  methods: {
    hideBtn(){
      this.showPayBtn = false
    },
    showTip(info){
      //console.log(info)
      this.tipInfo = info
      this.tipshow = true
    },
    showMessage(info){
      this.tipInfo = info
      this.tipshow = true
      this.btnshow = false
    },
    tipShow(){
      this.tipshow = false
      if(this.tipReload){
        //刷新页面
        location.reload();
      }
    },

    handleConfirm: function(){
      //隐藏支付按钮
      this.showPayBtn = false
      //将信息插入orderInfo中
      this.putOrderInfo.order = this.order
      var url = "https://bmh.hrcc5.com/server/sqb/searchOrder" //查询支付码接口  
      //alert(url)
      this.axios.post(   //请求方式
      url,  //接口地址
      this.putOrderInfo
      )    //传递参数 
      .then(response =>{
          if(response.data.code == 2000){
            console.log(response.data.data)
            // this.tipInfo = response.data.data.pay_info;
            // this.tipshow = true;
            //模拟点击支付
            var a = document.createElement("a");
                a.setAttribute("href", response.data.data.pay_info);
                // a.setAttribute("target", "_blank");
                a.click();
          }else{
            this.tipInfo = response.data.msg;
            this.tipshow = true;
          }
      })
      .catch((error) => {
          console.log(error)
          //alert("非常抱歉，出现系统内部错误！")
          this.tipInfo = "非常抱歉，系统出现内部错误！"+error;
          //this.tipInfo = error;
          this.tipshow = true;
          //显示支付按钮
          //this.showPayBtn = true
      })
    },
    handleBack:function(){
      this.order_page = false
      this.pay_page = false
      this.multi_page = true
      this.bsoll = true
      this.showPayBtn = true
    },
    fshowPayBtn: function(){
      this.showPayBtn = true
    },
  }
}
</script>

<style >
  body{
    margin-top: 0;
    margin-left: 0;
    margin-right: 0;
    margin-bottom: 0;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue